<template>
  <div class="container-fluid">
    <tax-group-form
      :loading="loading"
      :taxGroupData="taxGroup"
      :formErrors="formErrors"
      @taxGroupSubmitted="handleSubmit"
      @formChanged="() => (alertLeave = true)"
    />
  </div>
</template>

<script>
import { cloneDeep } from "lodash";
import alertLeave from "@/mixins/alert-leave-mixin";
import defaultTaxGroup from "../defaultTaxGroup";
import TaxGroupForm from "../partials/TaxGroupForm.vue";

export default {
  layout: "DashboardLayout",

  components: {
    TaxGroupForm,
  },

  mixins: [alertLeave],

  data() {
    const taxGroup = cloneDeep(defaultTaxGroup);
    if (this.$currentUserIsLevelOrganization()) {
      taxGroup.organization = {
        type: "organizations",
        id: this.$currentUserOrganizationId(),
      };
    }
    return {
      taxGroup,
      formErrors: null,
      loading: false,
    };
  },

  methods: {
    async handleSubmit(taxGroup) {
      this.loading = true;

      const taxGroupData = cloneDeep(taxGroup);
      delete taxGroupData.id;

      try {
        await this.$store.dispatch("taxGroups/add", taxGroupData);
        this.$notify({
          type: "success",
          message: this.$t("TAXES.TAX_GROUP_ADDED"),
        });
        const taxGroup = await this.$store.getters["taxGroups/taxGroup"];
        this.$emit("onViewTaxGroup", taxGroup, true);
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.formErrors = error.response.data.errors;
        this.loading = false;
      }
    },
  },
};
</script>
